module.exports = __webpack_public_path__ + "static/media/3.a9a320a1.png";